// import BaseSlider from '@blocks/BaseSlider'
import BaseView from './_BaseView'



/* VIEW: HOME
----------------------------------------------------------------------------------------------------*/

export default class Home extends BaseView {

    constructor(props) {
        super({ ...props, namespace: '.home' })

        this.on()
    }



}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



